$(function() {
$(document).on('click', '[data-header-drawer-toggle]', function (e) {
      this.login_drawer = $('[data-login-drawer]');
      this.login_drawer.toggleClass('is-visible');
       $('.theme-ajax-cart.is-visible').removeClass('is-visible');
       e.stopPropagation()
      });
var top_bar = $('.top-bar').innerHeight();
var header = $('.header').innerHeight();
var plus = top_bar + header
  $('.logout_modal').css('top', `${plus}px`)

function height(e) {
  var moblie_header = $('.mobile-header').innerHeight();
    if($(window).width() < 798){
      $('.logout_modal').css('top', `${moblie_header}px`)
    }
  }
  height();

function width(e) {
    var width = $(document).innerWidth();
      $('.logout_modal').css('left', `${width - 183}px`)
  }
  width();
  height();
  $(window).resize(function(){
    height();
   width();
  });

  // sticky header
$( window ).on( "scroll", function() {
 	var windowpos = $(window).scrollTop();
  	if (windowpos >= 100) {
      const headerHeight = $('.header-sticky-wrapper.is-sticky').outerHeight();
      $('.logout_modal').css('top', `${headerHeight}px`);
      $('.logout_modal').css('position', 'fixed');
	}
  else{
      var top_bar = $('.top-bar').innerHeight();
      var header = $('.header').innerHeight();
      var plus = top_bar + header
      $('.logout_modal').css('top', `${plus}px`)
      height();
  }
});
$(document).on("click", function(e) {
    if ($(e.target).is('.logout_modal') === false) {
      $(".logout_modal").removeClass("is-visible");
    }
  });
  });

/* MG (22 Jun 2026): enable :active press feedback on iOS Safari. iOS only applies :active styling
   when the page has a touch listener registered; this no-op passive listener switches it on, so the
   button invert + card press (mg-phase3-fixes.css) show on iPhone. Appended to this small site-wide
   file (loaded on every page via theme.liquid) so the 34KB theme.liquid stays untouched. */
document.addEventListener('touchstart', function () {}, { passive: true });

/* MG (22 Jun 2026, revised 28 Aug 2026): tap/press feedback - toggles .mg-press on the card or
   button being pressed. Styled in mg-card-press-fix.css (the collection-card photo dim) and
   mg-phase3-fixes.css (button invert). pointer events cover mouse, touch and pen.

   ⚠️ 28 Aug 2026 (Will, on a phone): "when swiping on Collpg, if a product card has a thicker frame
   and i lightly touch it while swiping it goes darker. can this be stopped so it only goes dark when
   tapped." The original version added .mg-press on pointerdown with a 300ms MINIMUM and cleared on
   pointerup/pointercancel -- so EVERY scroll that began with a finger on a card flashed the press
   state for at least 300ms. pointerdown fires immediately, BEFORE the browser has decided whether
   the gesture is a tap or a scroll, and the 300ms floor then guaranteed the flash was visible.

   THE FIX, three parts:
     ARM  90ms  nothing is shown until the finger has been down this long without travelling. A
                scroll declares itself well inside that window.
     SLOP 10px  any pointermove beyond this cancels outright, so a finger already moving when it
                lands -- Will's "lightly touch it while swiping" -- never arms at all.
     pointercancel cancels IMMEDIATELY and ignores the minimum. It means the browser has taken the
                gesture for scrolling, so there is nothing left to confirm and no reason to hold.

   A genuine quick tap still shows: pointerup before the timer arms it there and then, and MIN
   applies from that moment, so a fast tap gets a full 300ms rather than a single flickered frame.

   ⚠️ The ARM delay costs nothing perceptually on DESKTOP, because CSS `:active` already covers a
   held mouse press instantly. .mg-press exists only to EXTEND that past a quick release -- which is
   also why a 90ms delay is safe here and would not be if this class were the only mechanism.

   ⚠️ Moving the mouse more than SLOP while the button is held also cancels. That is correct: a drag
   is not a click.

   wishlist-button-collection added to the skip list 28 Aug -- it is the element name used on
   collection cards, and only .wk-button (the inner anchor) was covered before. */
(function () {
  var MIN = 300, ARM = 90, SLOP = 10;
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('.wk-button, wishlist-button, wishlist-button-collection, wishlist-button-product')) return; /* MG 27 Jun: skip the press feedback when tapping the Set Aside (wishlist) diamond */
    var el = e.target.closest ? e.target.closest('.button--add-to-cart, .product-wrap') : null;
    if (!el) return;
    var x0 = e.clientX, y0 = e.clientY, armed = false, done = false, start = 0;
    var timer = setTimeout(arm, ARM);
    function arm() {
      if (done) return;
      armed = true;
      start = Date.now();
      el.classList.add('mg-press');
    }
    function teardown() {
      clearTimeout(timer);
      document.removeEventListener('pointerup', finish);
      document.removeEventListener('pointercancel', cancel);
      document.removeEventListener('pointermove', move);
    }
    function cancel() {
      teardown();
      if (done) return;
      done = true;
      el.classList.remove('mg-press');
    }
    function finish() {
      teardown();
      if (done) return;
      done = true;
      if (!armed) { armed = true; start = Date.now(); el.classList.add('mg-press'); }
      setTimeout(function () { el.classList.remove('mg-press'); }, Math.max(0, MIN - (Date.now() - start)));
    }
    function move(ev) {
      if (Math.abs(ev.clientX - x0) > SLOP || Math.abs(ev.clientY - y0) > SLOP) cancel();
    }
    document.addEventListener('pointerup', finish);
    document.addEventListener('pointercancel', cancel);
    document.addEventListener('pointermove', move, { passive: true });
  }, { passive: true });
})();

/* MG (23 Jun 2026): keep the PDP Add-to-Cart LABEL from blanking during the add-to-cart animation.
   The theme empties the .text span (to draw its checkmark) which, on the cream "released" button,
   reads as an empty flash (Will). A MutationObserver refills it the instant it's emptied - the
   callback runs as a microtask BEFORE the browser paints, so the blank never shows. It only acts when
   the span is empty, so the theme's "Added to cart" swap (non-empty) still displays. PDP only. */
(function () {
  function guard(span) {
    if (!span || span.__mgGuard) return;
    span.__mgGuard = true;
    var original = (span.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
    new MutationObserver(function () {
      if (!span.textContent.trim()) span.textContent = original;
    }).observe(span, { childList: true, characterData: true, subtree: true });
  }
  function init() {
    var b = document.querySelectorAll('.purchase-details__buttons .button--add-to-cart');
    for (var i = 0; i < b.length; i++) guard(b[i].querySelector('.text'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* MG (23 Jun 2026): header account/login dropdown toggle. Clicking the Login/Account trigger
   (header__action-icons.liquid) opens an MG-styled menu (mg-phase3-fixes.css) instead of navigating;
   click-away or Esc closes it. The trigger's <a href> remains the no-JS fallback. */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-mg-account-toggle]') : null;
    var open = document.querySelector('[data-mg-account].is-open');
    if (trigger) {
      e.preventDefault();
      var wrap = trigger.closest('[data-mg-account]');
      var willOpen = !wrap.classList.contains('is-open');
      if (open && open !== wrap) open.classList.remove('is-open');
      wrap.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', String(willOpen));
      return;
    }
    if (open && !(e.target.closest && e.target.closest('[data-mg-account]'))) {
      open.classList.remove('is-open');
      var t = open.querySelector('[data-mg-account-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }, false);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var o = document.querySelector('[data-mg-account].is-open');
      if (o) { o.classList.remove('is-open'); var t = o.querySelector('[data-mg-account-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); }
    }
  }, false);
})();

/* MG (23 Jun 2026): PDP variant option label - strip the runtime-injected ": " from the
   <options-selection> web component label (e.g. "Colour:" -> "Colour"; uppercased + browned in
   mg-phase3-fixes.css). Liquid (options-select.liquid) renders no colon; the component adds it and
   re-renders on variant change, so a guarded MutationObserver re-strips. PDP only.
   ⚠️ 28 Aug 2026: these two regexes were briefly shipped as /\\s/ instead of /\s/ and were therefore
   dead. Cause: a GraphQL BLOCK string ({{"}}""") treats every backslash as literal -- only \""" is an
   escape -- so a doubled backslash written for safety lands in the file verbatim. Send files
   containing regexes through `variables` as a JSON string, where \\ correctly yields \, or write
   single backslashes in the block string. Verified after the fix by fetching the served asset and
   counting double backslashes: 0. */
(function () {
  function strip(scope) {
    (scope || document).querySelectorAll('.options-selection__option-name').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /:\s*$/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\s*:\s*$/, '');
      });
    });
  }
  function init() {
    strip();
    var host = document.querySelector('.product_form');
    if (host && window.MutationObserver) {
      var obs = new MutationObserver(function () { obs.disconnect(); strip(host); obs.observe(host, { subtree: true, childList: true, characterData: true }); });
      obs.observe(host, { subtree: true, childList: true, characterData: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* MG 28 Jun (Will sss): PDP back-in-stock - show "Email me when back in stock" only when the selected variant is out of stock, in place of Add to Cart. Visibility via .mg-bis-oos on .product_form (CSS in mg-phase3-fixes.css) so it survives the theme's AJAX variant re-render. */
(function(){
  function initBIS(){
    var pf = document.querySelector('.product_form');
    var select = document.querySelector('.shopify-product-form select[name="id"]') || document.querySelector('select[name="id"]');
    if(!pf || !select || !document.getElementById('BIS_trigger')) return;
    var availMap = {};
    [].forEach.call(select.options, function(o){ if(o.value && o.value !== 'not-selected') availMap[o.value] = !o.disabled; });
    function moveBis(){ var aw = pf.querySelector('.purchase-details__buttons'); var bis = document.getElementById('BIS_trigger'); if(aw && bis && bis.nextElementSibling !== aw){ aw.parentElement.insertBefore(bis, aw); } }
    function sync(){ moveBis(); pf.classList.toggle('mg-bis-oos', availMap[select.value] === false); }
    sync();
    var vs = document.querySelector('variant-selection');
    if(vs){ new MutationObserver(function(){ setTimeout(sync, 60); }).observe(vs, { attributes:true, attributeFilter:['variant'] }); }
    document.addEventListener('change', function(e){ if(e.target && e.target.name === 'id') setTimeout(sync, 60); });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initBIS); } else { initBIS(); }
})();

/* MG (25 Jul 2026): Makers hover-image cross-fade. Two places show a single preview img whose src the theme swaps instantly on maker hover, with no class hook so CSS alone cannot fade it: the megamenu (.append_colelction-img img) and the /pages/makers preview pane (.collection__info_img, driven by data-img-src on .get_content). On each src change we clone the OUTGOING image as an absolutely-positioned .mg-maker-ghost and fade it out over --mg-mm-imgdur (matches the Shop/Collections featured-image cross-fade), revealing the new image underneath. The ghost copies the source image object-fit and self-corrects its position after insertion so it overlays exactly regardless of which ancestor is the offset parent (both wraps are position:sticky). Ghost styles/timing live in mg-tweaks.css. */
(function () {
  function enhance(img) {
    if (img.__mgFade) return;
    img.__mgFade = true;
    var wrap = img.parentElement;
    if (!wrap) return;
    function spawnGhost(oldSrc) {
      var prev = wrap.querySelector('img.mg-maker-ghost');
      if (prev) prev.remove();
      var ir = img.getBoundingClientRect();
      if (!ir.width || !ir.height) return;
      var g = document.createElement('img');
      g.src = oldSrc;
      g.className = 'mg-maker-ghost';
      g.setAttribute('aria-hidden', 'true');
      g.style.objectFit = getComputedStyle(img).objectFit;
      g.style.width = ir.width + 'px';
      g.style.height = ir.height + 'px';
      g.style.top = '0px';
      g.style.left = '0px';
      wrap.appendChild(g);
      var gr = g.getBoundingClientRect();
      g.style.top = (ir.top - gr.top) + 'px';
      g.style.left = (ir.left - gr.left) + 'px';
      void g.offsetWidth;
      g.classList.add('mg-out');
      function kill() { if (g.parentNode) g.parentNode.removeChild(g); }
      g.addEventListener('transitionend', kill);
      setTimeout(kill, 2000);
    }
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName !== 'src') continue;
        var oldSrc = muts[i].oldValue;
        if (!oldSrc || oldSrc === img.getAttribute('src')) continue;
        spawnGhost(oldSrc);
      }
    }).observe(img, { attributes: true, attributeFilter: ['src'], attributeOldValue: true });
  }
  function initAll() {
    var l = document.querySelectorAll('.append_colelction-img img, .collection__info_img');
    for (var i = 0; i < l.length; i++) enhance(l[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  window.addEventListener('load', initAll);
})();

/* MG (25 Jul 2026): fade the makers-page maker description in on hover-change (Will). The theme swaps .collection_dec_append text instantly; re-trigger a fade-in keyframe (mgTextFade in mg-tweaks.css) on each change, at --mg-mm-imgdur to match the image cross-fade. Toggled in the observer microtask (before paint) so the new text starts at opacity 0 with no flash. */
(function () {
  function enhanceText(p) {
    if (p.__mgTextFade) return;
    p.__mgTextFade = true;
    new MutationObserver(function () {
      p.classList.remove('mg-textfade');
      void p.offsetWidth;
      p.classList.add('mg-textfade');
    }).observe(p, { childList: true, characterData: true, subtree: true });
  }
  function initText() {
    var t = document.querySelectorAll('.collection_dec_append');
    for (var i = 0; i < t.length; i++) enhanceText(t[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initText); else initText();
  window.addEventListener('load', initText);
})();

/* MG (28 Jul 2026): collection-page FILTER button (.fillter_button) alignment to the Shopify Inbox
   chat bubble's live vertical position.

   NOTE (28 Jul, Will): this used to also include a cover div that tried to blur/dim the chat bubble
   itself when the mega-menu was open (.mg-chat-blur-overlay, previously created here and styled in
   mg-filter-chat.css). That's been fully reverted per Will's instruction -- the chat widget is left
   completely alone now. For the record, in case anyone revisits this: two different blur techniques
   were tried and tested live (backdrop-filter on the cover div; a regular CSS `filter` on a wrapper
   around <shopify-chat>) and neither ever produced a visible blur -- the widget appears to render in
   a compositing layer that's isolated from both mechanisms, likely deliberately, for its own always-
   on-top behaviour. Directly setting `opacity` on <shopify-chat> also gets silently reverted by the
   widget's own script within the same tick. Don't re-attempt without a genuinely new technique.

   A first pass at the FILTER alignment hardcoded a static `bottom:88px` CSS override measured against
   one test window size -- Will reported it badly misaligned on his real browser. Root cause: the
   bubble's positioning wrapper resolves its offset relative to actual viewport height, not a fixed
   constant, so a single hardcoded value doesn't generalize across window sizes. Fix: read the bubble's
   ACTUAL current position live (getBoundingClientRect).

   LOAD-JUMP, PASS 2 (28 Jul, Will sss): button showed at custom.css's static bottom:18px default from
   first paint, then jumped once this JS found the widget. First fix hid the button (opacity 0) until
   positioned -- Will reported this reduced but did not remove the jump, and asked for it to load
   correctly positioned without being made invisible.

   LOAD-JUMP, PASS 3 (28 Jul): removed hide/reveal. Position driven entirely through one CSS custom
   property, --mg-filter-bottom, cached in sessionStorage and pre-applied via an early inline script in
   theme.liquid -- but scoped to sessionStorage, this only helps a SECOND+ page view within the SAME
   TAB. If Will's actual test pattern is a fresh tab/window each time (or Safari, which may differ),
   every test would look like a first-ever load and the fix would appear to do nothing -- consistent
   with his "still jumps" follow-up report.

   LOAD-JUMP, PASS 4 (28 Jul): switched the cache from sessionStorage to localStorage. The button's
   position is a property of the viewport/device, not of a browsing session, so there's no reason to
   throw the learned value away every time a tab closes -- localStorage persists across new tabs and
   browser restarts, so this should now be correct from first paint on EVERY visit after the very first
   one ever on a given browser, not just within one continuous tab session. The one-time resize-
   triggered re-measurement already in place still corrects it if the viewport genuinely changes. Also
   added a sanity check on the measured rect (must be roughly chat-bubble-sized) so a not-yet-settled
   shadow-DOM read during an early poll tick can't get cached or applied as final. A short opacity
   fade-in (mg-filter-chat.css, decoupled from position) still plays on every load. */
(function () {
  function getBubble() {
    var chat = document.querySelector('shopify-chat');
    var sr = chat && chat.shadowRoot;
    return sr ? (sr.querySelector('.activator') || sr.querySelector('[class*="activator"]')) : null;
  }
  function alignFilterButton(bubble) {
    var filterBtn = document.querySelector('.fillter_button');
    if (!filterBtn) return;
    if (window.innerWidth < 800) {
      document.documentElement.style.removeProperty('--mg-filter-bottom');
      return;
    }
    var r = bubble.getBoundingClientRect();
    if (!r.width || !r.height) return;
    /* Sanity check: the launcher bubble is a small, roughly-square icon (measured live at
       46x46px, though it can render smaller on other breakpoints). Reject anything well outside
       a plausible range -- a not-yet-laid-out shadow DOM read during an early poll tick can
       return a bogus or partial rect, and we never want to cache or apply that as final. */
    if (r.width < 15 || r.width > 100 || r.height < 15 || r.height > 100) return;
    var bottomOffset = window.innerHeight - r.bottom;
    document.documentElement.style.setProperty('--mg-filter-bottom', bottomOffset + 'px');
    try { localStorage.setItem('mgFilterBtnBottom', bottomOffset); } catch (e) {}
  }
  function sync() {
    var bubble = getBubble();
    if (!bubble) return;
    alignFilterButton(bubble);
  }
  function init() {
    sync();
    window.addEventListener('resize', sync);
    var tries = 0;
    var poll = setInterval(function () {
      sync();
      if (++tries > 30) clearInterval(poll);
    }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
